<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :items-per-page="-1"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">

            <template v-slot:[`item.${$constant.table.SALE_BOOKING_HISTORY_KEY.amountCommission}`]="{ item }">
                <div class="d-flex flex-row justify-content-center align-items-center">
                    <div class="font-weight-bold mt-2 mr-3">{{ $util.getCurrencyFormat(item.amountCommission) }}</div>
                    <v-select
                        outlined
                        hide-details
                        append-icon="expand_more"
                        height="40px"
                        v-model="item.isPaid"
                        item-value="value"
                        item-text="text"
                        v-on:change="changeStatus"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="statusList">
                        <template v-slot:item="{ item }">
                            <div
                                :class="{
                                    'green--text': item === 'paid',
                                    'red--text': item === 'pending'
                                }">
                                {{ $t(`status.${item}`) }}
                            </div>
                        </template>

                        <template v-slot:selection="{ item }">
                            <div
                                :class="{
                                    'green--text': item === 'paid',
                                    'red--text': item === 'pending'
                                }">
                                {{ $t(`status.${item}`) }}
                            </div>
                        </template>
                    </v-select>
                </div>
            </template>
            <template v-slot:[`item.${$constant.table.SALE_BOOKING_HISTORY_KEY.amount}`]="{ item }">
                <div class="font-weight-bold">{{ $util.getCurrencyFormat(item.amount) }}</div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import ExcludableTable from '@/mixins/ExcludableTable'

export default {
    name: 'BookingTable',

    components: {
        BaseTable
    },

    mixins: [ExcludableTable],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            statusList: [
                'pending',
                'paid'
            ],
            headers: [
                {
                    text: this.$t('saleAgent.historyTable.bookingNo'),
                    value: this.$constant.table.SALE_BOOKING_HISTORY_KEY.bookingNo,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.historyTable.staff'),
                    value: this.$constant.table.SALE_BOOKING_HISTORY_KEY.staff,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.historyTable.tourist'),
                    value: this.$constant.table.SALE_BOOKING_HISTORY_KEY.tickets,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.historyTable.total'),
                    value: this.$constant.table.SALE_BOOKING_HISTORY_KEY.amount,
                    sortable: false,
                    align: 'right'
                },
                {
                    text: this.$t('saleAgent.historyTable.commission'),
                    value: this.$constant.table.SALE_BOOKING_HISTORY_KEY.amountCommission,
                    sortable: false,
                    align: 'right'
                }
            ]
        }
    },

    computed: {
        processedItems () {
            return this.items.map(item => {
                return {
                    ...item
                }
            })
        }
    },

    methods: {
        onRowItemClick (item) {
            this.$emit('viewDetails', item)
        },
        changeStatus (value) {
            this.$emit('onChageSelect', value)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
